import React from 'react';
import {useTranslation} from "react-i18next";
import {LocalDocumentContentResponse} from "../../../models/local-documents.models";

import {formatOcrFileSize} from "../../../utils/ocr-utils";
import {
    DigitizedDocumentTypeBadge,
    StyledDigitizedDocumentFileInfo,
    StyledDigitizedDocument,
} from "./DigitizedDocumentFileInfo.styled";
import DigitizedDocumentStatus
    from "../DigitizedDocumentStatus";

interface DigitizedDocumentFileInfoProps {
    document: LocalDocumentContentResponse;
    isStatusVisible?: boolean;
}

const DigitizedDocumentFileInfo = ({document, isStatusVisible = false}: DigitizedDocumentFileInfoProps) => {
    const {t} = useTranslation();

    const contentType = document.contentType ?? <span>&nbsp;</span>;
    const fileName = document.fileName ?? '\u2014';
    const status = document.status ?? '';
    const numbOfPages = document.numbOfPages ? document.numbOfPages + t('documentsDigitization.pages') : '\u2014';
    const size = document.size ? formatOcrFileSize(document.size) : '\u2014';

    return (
        <StyledDigitizedDocument>
            <DigitizedDocumentTypeBadge $type={contentType}>
                {contentType}
            </DigitizedDocumentTypeBadge>

            <StyledDigitizedDocumentFileInfo>
                <span className="name">
                    {fileName}
                </span>

                <span className="info">
                    {(isStatusVisible && status) ? (<DigitizedDocumentStatus status={status} />) : ''}
                    {numbOfPages} &#8226; {size}</span>
            </StyledDigitizedDocumentFileInfo>
        </StyledDigitizedDocument>
    );
};

export default DigitizedDocumentFileInfo;